
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setDateOrdered = (dateOrdered: libTypes.Order['dateOrdered']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.dateOrdered = fns.order.set.dateOrdered(dateOrdered);
        })
    });
};